/* TradeTidy — Add to cart from the mini cart's "You may also like" cards.
   Delegated listeners (the drawer re-renders its footer on every cart change, so
   per-card listeners would be lost). Adds via /cart/add.js, then hands the response
   to the theme's <mini-cart> so the drawer re-renders in place, same as the bundle builder. */
(function () {
  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || "/cart/add";
  }

  document.addEventListener("change", function (event) {
    var select = event.target.closest && event.target.closest(".js-cross-sell-variant");
    if (!select) return;
    var card = select.closest(".mini-cart-cross-sell-card");
    if (!card) return;
    var button = card.querySelector(".js-cross-sell-add");
    if (button) button.dataset.variantId = select.value;
    var option = select.options[select.selectedIndex];
    var price = card.querySelector(".js-cross-sell-price");
    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
  });

  document.addEventListener("click", function (event) {
    var button = event.target.closest && event.target.closest(".js-cross-sell-add");
    if (!button || button.disabled) return;
    event.preventDefault();
    var variantId = parseInt(button.dataset.variantId, 10);
    if (!variantId) return;

    var minicart = document.querySelector("mini-cart");
    var sections =
      minicart && typeof minicart.getSectionsToRender === "function"
        ? minicart.getSectionsToRender().map(function (s) { return s.section; })
        : [];

    var label = button.dataset.label || button.textContent;
    button.disabled = true;
    button.textContent = "Adding…";

    fetch(cartAddUrl(), {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (json) { return { ok: response.ok, json: json }; });
      })
      .then(function (result) {
        if (!result.ok) {
          button.disabled = false;
          button.textContent = (result.json && result.json.description) || "Try again";
          return;
        }
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartItemAdd, { source: "mini-cart-cross-sell" });
        }
        if (minicart && typeof minicart.renderContents === "function") {
          minicart.renderContents(result.json);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || "/cart";
        }
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = label;
      });
  });
})();
